<template>
  <div class="p-6">
    <div class="border border-gray-200 rounded-lg overflow-hidden">
      <ProviderRosterReport />
    </div>
  </div>
</template>

<script>
import ProviderRosterReport from './ProviderRosterReport.vue'

export default {
  name: 'Rostering_Test',
  components: {
    ProviderRosterReport,
  },
}
</script>
